import Header from "../components/header";
import HeaderSection from "../components/header-section";
import BoxNullItems from "../components/boxNullItems";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { hasSurveyModules } from "../utils/helpers";

const Dashboard = () => {
  const { t } = useTranslation();
  const { namePharmacy } = useSelector((state: any) => state.login);
  const { user } = useSelector((state: any) => state.login);

  return (
    <>
      <Header titleLogOut={user?.name} />

      <HeaderSection titleSection={namePharmacy} />

      <BoxNullItems
        icon={hasSurveyModules(user) ? "inventory" : "edit_calendar"}
        buttonLabel={t("start-now")}
        label={hasSurveyModules(user) ? t("not-pharmacy") : t("not-event")}
      />
    </>
  );
};

export default Dashboard;
